// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2jadu","title":"ClientReferral_title__23DEc","itemText":"ClientReferral_itemText__BIFSF"};